import { combineEpics } from 'redux-observable';
import deleteFilter from './delete-filter/index.tsx';
import getAssociatedItems from './get-associated-items/index.tsx';

// @ts-expect-error - TS2769 - No overload matches this call.
export default combineEpics(deleteFilter, getAssociatedItems);
